import React from 'react';
import { Input, Tooltip } from 'antd';
import { MAX_INPUT_CHAT_MESSAGE_LENGTH } from '../chat-bot.constants';
import ChatBotSendIcon from '@svg/chat-bot-send.svg?react';

interface ChatFooterProps {
    value: string;
    setValue: (v: string) => void;
    sendMessage: () => void;
}

export const ChatFooter: React.FC<ChatFooterProps> = ({value, setValue, sendMessage}) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            sendMessage();
        }
    };

    return (
        <div className="chat-footer">
            <Tooltip
                title={`Maximum ${MAX_INPUT_CHAT_MESSAGE_LENGTH} characters allowed`}
                open={value.length >= MAX_INPUT_CHAT_MESSAGE_LENGTH}
                placement="top">
                <div className="chat-input">
                    <Input.TextArea
                        className="chat-input-textarea"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        placeholder="Ask Andi"
                        onKeyDown={handleKeyDown}
                        maxLength={MAX_INPUT_CHAT_MESSAGE_LENGTH}
                        autoSize={false}/>
                    <ChatBotSendIcon onClick={sendMessage}/>
                </div>
            </Tooltip>
        </div>
    );
};